import { render } from "./SleepTime.vue?vue&type=template&id=5610248a"
import script from "./SleepTime.vue?vue&type=script&lang=js"
export * from "./SleepTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__